import React from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import { useAccountSelector, usePlaidSelector } from "store";
import { Box, Collapse, Typography } from "@mui/material";
import { RoleComponentGuard } from "components/guards/Role-component.guard";
import { RoleName } from "constants/index";
import { Routes } from "constants/routes";
import { useDevice, useNavigate } from "hooks";
import { useAccountSelector, useGPTSelector, usePlaidSelector } from "store";

import { ReactComponent as AdminToolsIcon } from "../../../assets/icons/admin-tools-sidebar.svg";
import { DataUploader } from "../Data-uploader/DataUploader";
import { LinkParams } from "../Sidebar";

interface IProps {
  setAdminToolsOpen: (value: boolean) => void;
  // setAdditionReportsOpen: (value: boolean) => void;
  adminToolsOpen: boolean;
  selectedOption: string;
  onCloseSidebar: () => void;
  onNavigate?: (route: string) => void;
  isHamburgerMenu?: boolean;
}

export const AdminToolsMenu: React.FC<IProps> = ({
  setAdminToolsOpen,
  // setAdditionReportsOpen,
  adminToolsOpen,
  selectedOption,
  onCloseSidebar,
  onNavigate,
  isHamburgerMenu = false
}) => {
  const navigate = useNavigate();
  // const dataRooms = useAccountSelector()?.allow_dataroom;
  const isPlaidEnabled = usePlaidSelector();
  const isGPTEnabled = useGPTSelector();
  const { enable_portfolio_construction } = useAccountSelector() || {};
  const { isMobile } = useDevice();

  const dropMenuItemsStyles = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    padding: "5px 10px",
    ":hover": { background: "#0f3a54", color: "#ffffff" },
    cursor: "pointer",
    borderRadius: "8px",
    fontSize: "15px",
    color: "#92a7bc"
  };

  const menuItemStyles = {
    borderRadius: "8px",
    width: "100%",
    ":hover": { background: "#0f3a54" },
    display: "flex",
    alignItems: "center",
    padding: "3px 7px 3px 7px",
    color: "#92a7bc",
    fontSize: "15px",
    cursor: "pointer"
  };

  const adminTools: LinkParams[] = [
    {
      route: "investorsList",
      path: Routes.investorsList,
      title: "Investors",
      enabled: true
    },
    // {
    //   route: "dataRooms",
    //   path: Routes.dataRooms,
    //   title: "Data Rooms",
    //   enabled: dataRooms
    // },
    {
      route: "measures",
      path: Routes.measures,
      title: "Measures",
      enabled: true
    },
    {
      route: "characteristics",
      path: Routes.characteristics,
      title: "Characteristic",
      enabled: true
    },
    {
      route: "plaid",
      path: Routes.plaid,
      title: "Plaid",
      enabled: isPlaidEnabled
    },
    {
      route: "gptPrompt",
      path: Routes.gptPrompt,
      title: "GPT Prompt",
      enabled: isGPTEnabled
    },
    {
      route: "assetClasses",
      path: Routes.assetClasses,
      title: "Asset Classes",
      enabled: true
    },
    {
      route: "objectiveDefaults",
      path: Routes.objectiveDefaults,
      title: "Objective Defaults",
      enabled: !!enable_portfolio_construction
    },
    {
      route: "accountSettings",
      path: Routes.accountSettings,
      title: "Account Settings",
      enabled: true
    }
  ];

  return (
    <RoleComponentGuard availableRoles={[RoleName.Admin]}>
      <Box
        sx={{
          boxShadow: "0 -4px 13px 0 rgba(0, 0, 0, 0.2)",
          padding: "10px 0",
          background: "#071f35",
          width: "100%",
          bottom: "0",
          position: "absolute",
          border: "1px solid #496682"
        }}
      >
        <Box sx={{ padding: "0 15px", width: "100%" }}>
          <Box
            onClick={() => {
              setAdminToolsOpen(!adminToolsOpen);
              // setAdditionReportsOpen(false);
            }}
            sx={{
              ...menuItemStyles,
              justifyContent: "space-between",
              ":hover": { background: "#0f3a54" },
              marginBottom: adminToolsOpen ? "10px" : "0",
              transition: "margin-bottom 0.3s ease",
              ...(selectedOption === "admin tools" && {
                backgroundColor: "#496682",
                borderRadius: "8px",
                color: "#ffffff"
              })
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  minWidth: "27px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  ...(selectedOption === "admin tools" && { "& svg": { fill: "#ffffff !important" } })
                }}
              >
                <AdminToolsIcon style={{ fill: "#92a7bc", width: "14px" }} />
              </Box>
              <Typography sx={{ whiteSpace: "nowrap", overflow: "hidden", fontSize: isMobile ? "20px" : "15px" }}>
                Admin Tools
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                transition: "transform 0.3s ease",
                transform: adminToolsOpen ? "rotate(180deg)" : "rotate(0deg)"
              }}
            >
              <KeyboardArrowDownIcon sx={{ color: selectedOption === "admin tools" ? "#ffffff" : "#92a7bc" }} />
            </Box>
          </Box>
          <Collapse in={adminToolsOpen} timeout="auto" unmountOnExit>
            <Box
              sx={{
                borderLeft: "1px solid #496682",
                marginLeft: "15px",
                paddingLeft: "16px",
                fontSize: "15px",
                color: "#92a7bc",
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                paddingTop: "10px",
                paddingBottom: "10px"
              }}
            >
              {adminTools.map(({ route, title, enabled }, index) => {
                return (
                  enabled && (
                    <Typography
                      key={index}
                      onClick={() => {
                        if (onNavigate) {
                          onNavigate(route);
                        } else {
                          navigate({ route: route });
                          onCloseSidebar();
                        }
                      }}
                      sx={{
                        ...dropMenuItemsStyles,
                        fontSize: isMobile ? "20px" : "15px"
                      }}
                    >
                      {title}
                    </Typography>
                  )
                );
              })}

              <DataUploader isHamburgerMenu={isHamburgerMenu} />
            </Box>
          </Collapse>
        </Box>
      </Box>
    </RoleComponentGuard>
  );
};
